import { library, config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Pro Light
import {
  faBars,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faCheck,
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
  faUser,
  faSpinner,
  faShoppingBasket,
  faSearch,
  faTags,
  faClockRotateLeft,
  faCopyright,
  faLocationArrow,
  faPhone,
  faEnvelope,
  faMapMarker,
  faClock,
  faCalendar,
  faLink,
  faExclamationTriangle,
  faExclamationCircle,
  faExclamation,
  faMapPin,
  faCalendarDays,
  faReceipt,
  faTruck,
  faCircleCheck,
  faMagnifyingGlass,
  faSliders,
  faHatChef,
  faCirclePlus,
  faCircleMinus,
  faInfoCircle,
  faRotateLeft,
  faLock,
  faTrash,
  faGift,
  faEye,
  faEyeSlash,
  faDownload,
  faPrint,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faSealQuestion,
  faPencil,
  faArrowLeft,
  faSwap,
  faHandWave,
  faBook,
  faUtensils,
  faBagShopping,
  faLocationDot,
  faTag,
  faRotateRight as falRotateRight,
} from "@fortawesome/pro-light-svg-icons";

// Pro Regular
import { faRotateRight } from "@fortawesome/pro-regular-svg-icons";

// Pro Solid
import {
  faXmark,
  faStar,
  faShoppingCart,
  faFaceSmile,
  faFaceFrown,
  faFire,
  faSnowflake,
} from "@fortawesome/pro-solid-svg-icons";

// Brands
import {
  faFacebook,
  faTwitter,
  faXTwitter,
  faInstagram,
  faLinkedin,
  faGoogle,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

// Duotone
import { faSquareCheck } from "@fortawesome/pro-duotone-svg-icons";

library.add(
  faBars,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faCheck,
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
  faUser,
  faSpinner,
  faShoppingBasket,
  faSearch,
  faTags,
  faClockRotateLeft,
  faCopyright,
  faLocationArrow,
  faPhone,
  faEnvelope,
  faMapMarker,
  faClock,
  faCalendar,
  faLink,
  faExclamationTriangle,
  faExclamationCircle,
  faExclamation,
  faMapPin,
  faCalendarDays,
  faReceipt,
  faTruck,
  faCircleCheck,
  faMagnifyingGlass,
  faSliders,
  faHatChef,
  faCirclePlus,
  faCircleMinus,
  faInfoCircle,
  faRotateLeft,
  faLock,
  faTrash,
  faGift,
  faEye,
  faEyeSlash,
  faDownload,
  faPrint,
  faArrowRight,
  faArrowLeft,
  faArrowUp,
  faArrowDown,
  faSealQuestion,
  faRotateRight,
  faXmark,
  faPencil,
  faStar,
  faShoppingCart,
  faFaceSmile,
  faFaceFrown,
  faFacebook,
  faXTwitter,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGoogle,
  faWhatsapp,
  faSwap,
  faSquareCheck,
  faHandWave,
  faBook,
  faFire,
  faSnowflake,
  faUtensils,
  faBagShopping,
  faLocationDot,
  faTag,
  falRotateRight,
);

config.autoAddCss = false;

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("fa", FontAwesomeIcon);
});
